// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_gm","galleryThumbnail_active":"c-p_gn","galleryThumbnail__image":"c-p_go"};